export class ConfirmationWarningDialogData {
  title: string;
  displayText: string;
  confirmBtnName?: string;
  cancelBtnName?: string;
  hideCancelBtn?: boolean;

  constructor(
    title: string = null,
    displayText: string = null,
    confirmBtnName: string = null,
    cancelBtnName: string = null,
    hideCancelBtn: boolean = false
  ) {
    this.title = title;
    this.displayText = displayText;
    this.confirmBtnName = confirmBtnName;
    this.cancelBtnName = cancelBtnName;
    this.hideCancelBtn = hideCancelBtn;
  }
};
